module.exports = __webpack_public_path__ + "static/hr_capabilities_4-b882b383db9163cb745453632a8f81a9.png";